import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import WebHome from "./pages/WebHome";

const WebAbout = lazy(() => import("./pages/WebAbout"));
const WebBooking = lazy(() => import("./pages/WebBooking"));
const WebContact = lazy(() => import("./pages/WebContact"));
const WebFleet = lazy(() => import("./pages/WebFleet"));
const WebHpnAirportCarService = lazy(() => import("./pages/WebHpnAirportCarService"));
const WebWestchesterAirportCarService = lazy(() => import("./pages/WebWestchesterAirportCarService"));
const WebYorktownHeightsBlackCarService = lazy(() => import("./pages/WebYorktownHeightsBlackCarService"));
const WebManhattanPrivateCarService = lazy(() => import("./pages/WebManhattanPrivateCarService"));
const WebNewYorkTransportation = lazy(() => import("./pages/WebNewYorkTransportation"));
const WebOnlineBooking = lazy(() => import("./pages/WebOnlineBooking"));
const WebServices = lazy(() => import("./pages/WebServices"));

function WebRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<WebHome />} />
        <Route path="/fleet" element={<WebFleet />} />
        <Route path="/services" element={<WebServices />} />
        <Route path="/hpn-airport-car-service" element={<WebHpnAirportCarService />} />
        <Route path="/westchester-airport-car-service" element={<WebWestchesterAirportCarService />} />
        <Route path="/yorktown-heights-black-car-service" element={<WebYorktownHeightsBlackCarService />} />
        <Route path="/manhattan-private-car-service" element={<WebManhattanPrivateCarService />} />
        <Route path="/jet-black-transportation" element={<WebNewYorkTransportation />} />
        <Route path="/online-booking" element={<WebOnlineBooking />} />
        <Route path="/booking" element={<WebBooking />} />
        <Route path="/about" element={<WebAbout />} />
        <Route path="/contact" element={<WebContact />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

export default WebRoutes;
